import { NgModule } from "@angular/core";
import { WishListPdtComponent } from './wish-list-pdt.component';
import { CommonModule } from "@angular/common";
import { PipeModule } from "@app/pipes/pipe.module";
import { ComponentsModule } from "@app/components/components.module";

@NgModule({
    declarations: [
        WishListPdtComponent
    ],
    imports: [
        CommonModule,
        ComponentsModule,
        PipeModule,
    ],
    exports: [
        WishListPdtComponent
    ]
})
export class WishListPdtModule{}